module.exports = __webpack_public_path__ + "img/22.12174b0a.png";